import { combineReducers } from "redux";
import eloquaReducer from "./redux/eloqua/eloqua-reducer";
import formEntryReducer from "./redux/form-entry/form-entry-reducer";
import formSubmittedReducer from "./redux/form-submitted/form-submitted-reducer";
import formErrorReducer from "./redux/form-errors/form-errors-reducer";
import geoipReducer from "./redux/geoip/geoip-reducer";

const rootReducer = combineReducers({
    eloqua: eloquaReducer,
    formData: formEntryReducer,
    formSubmitted: formSubmittedReducer,
    formErrors: formErrorReducer,
    geoip: geoipReducer
});

export default rootReducer;
